import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BoxComponent, HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-section-field',
  templateUrl: './evaluation-section-field.component.html',
  styleUrls: ['./evaluation-section-field.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BoxComponent, HeadingComponent],
})
export class EvaluationSectionFieldComponent {
  public readonly title = input<string>('');
  public readonly description = input<string>('');
}
